"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = useColumns;
var react_1 = require("react");
var usehooks_ts_1 = require("usehooks-ts");
var local_storage_names_1 = require("../../../../../../constants/local_storage_names");
var INITIAL_VISIBLE_COLUMNS = [
    "date_time",
    "user_name",
    "reward_track_name",
    "reward_track_type",
    "previous_tier_name",
    "new_tier_name",
    "rewards_granted",
    "xp_points_earned",
];
function useColumns() {
    var _a = (0, react_1.useState)("all"), visibleColumns = _a[0], setVisibleColumns = _a[1];
    var _b = (0, usehooks_ts_1.useLocalStorage)(local_storage_names_1.TRANSACTION_COLUMN_CONFIG_STORAGE, {
        initialVisibleColumns: INITIAL_VISIBLE_COLUMNS,
        visibleColumns: "all",
    }), tableColumnConfig = _b[0], setTableColumnConfig = _b[1];
    var columns = (0, react_1.useMemo)(function () { return [
        { name: "Date", uid: "date_time" },
        { name: "User ID", uid: "user_id" },
        { name: "User Name", uid: "user_name" },
        { name: "Reward Track", uid: "reward_track_name" },
        { name: "Type", uid: "reward_track_type" },
        { name: "Milestone", uid: "milestone_name" },
        { name: "Previous Tier", uid: "previous_tier_name" },
        { name: "Previous Tier Value", uid: "previous_tier_value" },
        { name: "New Tier", uid: "new_tier_name" },
        { name: "New Tier Value", uid: "new_tier_value" },
        { name: "Source Statistic", uid: "source_statistic" },
        { name: "Source Value", uid: "source_value" },
        { name: "Rewards Granted", uid: "rewards_granted" },
        { name: "Points", uid: "xp_points_earned" },
    ]; }, []);
    var excludeSortColumns = (0, react_1.useMemo)(function () { return columns.filter(function (_a) {
        var sortable = _a.sortable;
        return sortable !== true;
    }); }, [columns]);
    var headerColumns = (0, react_1.useMemo)(function () {
        if (!columns || !columns.length) {
            return [];
        }
        return columns
            .map(function (item) {
            return item;
        })
            .filter(function (column) { return (visibleColumns !== "all" ? Array.from(visibleColumns).includes(column.uid) : column); })
            .map(function (column) { return (__assign(__assign({}, column), { id: column.uid })); });
    }, [columns, visibleColumns]);
    var onVisibleColumnsChanged = (0, react_1.useCallback)(function (keys) {
        setVisibleColumns(keys);
    }, []);
    (0, react_1.useEffect)(function () {
        onVisibleColumnsChanged(tableColumnConfig.visibleColumns);
    }, [tableColumnConfig]);
    return (0, react_1.useMemo)(function () { return ({
        columns: columns,
        excludeSortColumns: excludeSortColumns,
        headerColumns: headerColumns,
        onVisibleColumnsChanged: onVisibleColumnsChanged,
        setTableColumnConfig: setTableColumnConfig,
        tableColumnConfig: tableColumnConfig,
        visibleColumns: visibleColumns,
    }); }, [columns, excludeSortColumns, headerColumns, onVisibleColumnsChanged, setTableColumnConfig, tableColumnConfig, visibleColumns]);
}
